import { Link } from '@inertiajs/react'
import { FiHome, FiUser } from 'react-icons/fi'
import { Wave } from './PageHeader'

export default function BottomNav({ current }: { current: 'home' | 'profile' }) {
  return (
    <div className="ho-nav-wrap">
      <Wave />
      <nav className="ho-nav" aria-label="Main">
        <Link href="/home" aria-current={current === 'home' ? 'page' : undefined}><FiHome aria-hidden="true" />Home</Link>
        <Link href="/profile" aria-current={current === 'profile' ? 'page' : undefined}><FiUser aria-hidden="true" />Profile</Link>
      </nav>
    </div>
  )
}
